import { jsx as _jsx } from "react/jsx-runtime";
import { getFieldTitle } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { DisplayText } from "../../DisplayText";
export var SubtitleField = function (props) {
    var rawUiSchema = props.uiSchema, _a = props.formContext, formContext = _a === void 0 ? {} : _a;
    var uiSchema = rawUiSchema;
    // @ts-ignore TODO: Typescript upgrade
    var title = getFieldTitle(uiSchema, formContext);
    return (_jsx(DisplayText, { element: "h5", size: "small", children: title }));
};
